import { ThunkAPI } from '../rootReducer';
import { HttpMethods, SERVICES } from '../../services/api';
import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { IPackageInfoPayload } from '.';
import { AccessTypes } from '../../components/common/domain/accountAccessType';
import { selectors } from '../auth';
import { getDefaultCoreUrl } from '../../components/auth/utils/getUrlToRedirect';

/** @deprecated Use src/slices/auth/auth.thunk.ts instead */
export const getPackagesInfo: AsyncThunk<IPackageInfoPayload, void, ThunkAPI> = createAsyncThunk(
  'packagesInfo/getPackagesInfo',
  async (_, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<IPackageInfoPayload, void>({
        endpoint: 'auth',
        microservice: SERVICES.AUTH_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(_, thunk);

      return response;
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);

interface IProTrialRequest {
  type: 'PROFESSIONAL';
}

export const startProTrial: AsyncThunk<void, void, ThunkAPI> = createAsyncThunk(
  'startProTrial',
  async (_, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IProTrialRequest>({
        endpoint: 'features/setup-trial',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })({ type: 'PROFESSIONAL' }, thunk);
      const state = thunk.getState();
      const user = selectors.getLoggedInUser(state);
      const token = selectors.getAuthToken(state);
      const coreUrl = getDefaultCoreUrl(user?.account);
      thunk.dispatch(showSuccessMessage('Professional trial started'));
      thunk.dispatch(getPackagesInfo());
      window.location.href = `${coreUrl}?token=${token}&userId=${user?.id}`;
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage(err as string || 'An error occurred requesting your trial'));
      return thunk.rejectWithValue(err);
    }
  }
);

interface IEnterpriseTrialRequest {
  accountId: string;
  type: AccessTypes.Enterprise;
}

export const startEnterpriseTrial: AsyncThunk<void, string, ThunkAPI> = createAsyncThunk(
  'startEnterpriseTrial',
  async (accountId, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IEnterpriseTrialRequest>({
        endpoint: 'features/setup-trial',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })({ type: AccessTypes.Enterprise, accountId }, thunk);
      thunk.dispatch(showSuccessMessage('Enterprise trial started'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage(err as string || 'An error occurred requesting your trial'));
      return thunk.rejectWithValue(err);
    }
  }
);
